import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductDetails.css"; // Custom styles
import { NavLink } from "react-router-dom";
import { FaFilter, FaTimes, FaChevronDown } from "react-icons/fa";
import { User, Mail, Phone, Square } from "lucide-react";
import "./Products.css";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { FaArrowDown } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation"
const productData = [
    {
        category: "pv",
        name: "PV SERIES",
        detail: "Capacity : <br /> 145 m³/h to 19,345 m³/h <br />85 CFM TO 11,385 CFM",
        image: require("../images/products/PV-SERIES.png"),
        brochure: require("../images/brochures/PVSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 145 m³/h to 19,345 m³/h (85 CFM TO 11,385 CFM)",
            maxVacuum: "MAX. VACUUM : 700 mm Hg (27.5\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            // intro: `Body, Heads & Cones are made of close grained heavy duty Cast Iron, Rotor is made of Spheroidal Graphite (S.G) Iron free from cavities and blow holes. Shaft is made of Carbon Steel and carries one and only moving part, Rotor which is dynamically balanced for a vibration free running. Shaft is carried on both ends by bearings which maintain close running clearance between working parts throughout the working life of Pump. Bearings are grease lubricated before shipment and require no further lubrication for approximately six months. <br />Pumps can also be supplied in ceramic coating, total or cladded CF8 (S.S 304) and CF8M (S.S 316) grades.`,
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [""]
        },
        graph: require("../images/graphs/PV-Series.png")
    },
    {
        category: "premier",
        name: "PREMIER SERIES",
        detail: "Capacity : <br /> 4,010 m³/h to 22,470 m³/h <br /> 2,360 CFM to 13,225 CFM",
        image: require("../images/products/PREMIER-SERIES.png"),
        brochure: require("../images/brochures/PremierSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 4,010 m³/h to 22,470  m³/h (2,360 CFM to 13,225 CFM)",
            maxVacuum: "MAX. VACUUM : 620 mm Hg (24.5\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "ps",
        name: "PS SERIES",
        detail: "Capacity :<br /> 120 m³/h to 2,235 m³/h <br /> 70 CFM to 1,315 CFM",
        image: require("../images/products/PS-SERIES.png"),
        brochure: require("../images/brochures/PSSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 120 m³/h to 2,235 m³/h (70 CFM to 1,315 CFM)",
            maxVacuum: "MAX. VACUUM : 710 mm Hg (28” Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",
            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "pxl",
        name: "PXL SERIES",
        detail: "Capacity :<br /> 105 m³/h to 5,960 m³/h <br /> 60 CFM to 3,510 CFM",
        image: require("../images/products/PXL-SERIES.png"),
        brochure: require("../images/brochures/PXLSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 105 m³/h to 5,960 m³/h (60 CFM to 3,510 CFM)",
            maxVacuum: "MAX. VACUUM : 710 mm Hg (28\" Hg) at mean Mean Sea Level (MSL)",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",
            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "p2be",
        name: "P2BE SERIES",
        detail: "Capacity :<BR /> 4,000 m³/h to 72,000 m³/h<br /> (2,345 CFM  to 42,380 CFM)",
        image: require("../images/products/P2BE-SERIES.png"),
        brochure: require("../images/brochures/PowerPlant-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 4,000 m³/h to 72,000 m³/h (2,345 CFM  to 42,380 CFM)",
            maxVacuum: "MAX. VACUUM : 640 mm Hg (25.1\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",
            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "p501",
        name: "P501 SERIES",
        detail: "Capacity :<br /> 3,400  m³/h to 33,215 m³/h <br /> 2,000 CFM to 19,550 CFM",
        image: require("../images/products/P501-SERIES.png"),
        brochure: require("../images/brochures/P501Series-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 3,400  m³/h to 33,215 m³/h (2,000 CFM to 19,550 CFM)",
            maxVacuum: "MAX. VACUUM : 700 mm Hg (27.5\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",
            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "pws",
        name: "PWS SERIES",
        detail: "Capacity :<br /> 175 m³/h to 2,150 m³/h <br /> 105 CFM to 1,265 CFM",
        image: require("../images/products/PVW-SERIES.png"),
        brochure: require("../images/brochures/PWSSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 175 m³/h to 2,150 m³/h (105 CFM to 1,265 CFM)",
            maxVacuum: "MAX. VACUUM : 710 mm Hg (27.9\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "pa",
        name: "PA SERIES",
        detail: "",
        image: require("../images/products/PA-140-SERIES.png"),
        brochure: require("../images/brochures/PowerPlant-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "",
            maxVacuum: "",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "pat",
        name: "PAT SERIES",
        detail: "",
        image: require("../images/products/PAT-SERIES.png"),
        brochure: require("../images/brochures/PowerPlant-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "",
            // maxVacuum: "675 mm Hg (26.6\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "pshr",
        name: "PSHR SERIES",
        detail: "",
        image: require("../images/products/PSHR-SERIES.png"),
        brochure: require("../images/brochures/PowerPlant-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "",
            maxVacuum: "",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "ptc",
        name: "PTC SERIES",
        detail: "",
        image: require("../images/products/PTC-SERIES.png"),
        brochure: require("../images/brochures/PowerPlant-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "",
            // maxVacuum: "665 mm Hg (26.2\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "plh",
        name: "PLH SERIES",
        detail: "Capacity :<br /> 120 m³/h to 695 m³/h <br /> 70 CFM to 410 CFM",
        image: require("../images/products/PLH -SERIES.png"),
        brochure: require("../images/brochures/PLHSeries-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE :  120 m³/h to 695 m³/h (70 CFM to 410 CFM)",
            maxVacuum: "MAX. VACUUM : 710 mm Hg (28\" Hg) at mean Mean Sea Level (MSL)",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    },
    {
        category: "wxp",
        name: "WXP SERIES",
        detail: "",
        image: require("../images/products/WXP-SERIES.png"),
        brochure: require("../images/brochures/WXPseries-Broucher-India.pdf"),
        description: {
            intro:
                `<p> PREMIER Water Extraction Pumps (WXP) play a vital role in the dewatering of a Vacuum system which consists of a receiver fitted with the WXP which are designed to operate at low NPSH conditions. </p>
            <p>These dewatering pumps prevent flooding of the Liquid Ring Vacuum Pump with process water which otherwise will result in reduced capacity and increase in power consumption of the Vacuum Pump.<p />
            <p>Advantages of the dewatering system: <p />`,
            maxVacuum: "",
            features: [
                "Prevent fluctuations in Vacuum level.",
                "Optimal power consumption and airflow capacity of Vacuum Pump are maintained.",
                "Since process water is isolated from the Vacuum Pump, effects of corrosion are reduced, increasing service life of the Vacuum Pump.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron (Impeller in Stainless Steel) and Stainless Steel materials based on the application.</p>
            <p> A wide variety of Stainless Steel grades such as CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of corrosion in the application. <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options.<p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements.<p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades. </p>
           <p>Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [""]
        }
    },
    {
        category: "p9000",
        name: "P9000",
        detail: "Capacity :<br /> 9,770 to 23,060 m³/h <br /> 5,750 CFM to 13,570 CFM",
        image: require("../images/products/P9000-SERIES.png"),
        brochure: require("../images/brochures/P9000-Series-Broucher-India.pdf"),
        description: {
            intro: "",
            capacity: "CAPACITY RANGE : 9,770 m³/h to 23,060 m³/h (5,750 CFM to 13,570 CFM)",
            maxVacuum: "MAX. VACUUM : 700 mm Hg (27.5\" Hg) at Mean Sea Level",
            features: [
                "Pumps and Spares are 100% interchangeable with other O.E.M pumps.",
                "Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) materials based on the application.",
                "Rotor-Shaft assemblies are dynamically balanced complying with ISO 1940 G6.3",
                "Pumps are performance tested complying with BS 1571-2:1975 & PNEUROP 6612-1984.",

            ]
        },
        constructionalFeatures: {
            intro: `<p> Pumps and Spares can be supplied in Cast Iron, Ductile Iron (Rotor) and Stainless Steel materials based on the application.</p>
            <p>A wide variety of Stainless Steel grades such as CA15 (S.S. 410), CF8 (S.S. 304) and CF8M (S.S. 316) are available depending on the intensity of erosion and corrosion in the application. <p />
            <p>Cost savings can be achieved using Cast Iron/Ductile Iron base materials with Stainless Steel cladding and Ceramic Coating options. Cladding can be done in S.S. 304 and S.S. 316 options. Sufficient thickness of cladding is done to ensure a reasonable working life of the Pump or Spare.  <p />
            <p>Pump’s shaft is made with Ultrasonic cleared Carbon Steel (EN grade) or Stainless Steel grade options. <p />
            <p>Stuffing box sealing of Pump is done with Mechanical seals or Packing glands depending on the site requirements. <p />
            <p>Wet and dry fasteners are supplied in Stainless Steel and High Tensile grades.
           <p> Non Asbestos gaskets and gland packing rope are used.</p>`,
            features: [
                ""
            ]
        }
    }
];

function ProductDetails() {
    const swiperRef = useRef(null);

    //
    const [showFormPopup, setShowFormPopup] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);


    const handleReachOut = (context) => {
        setShowFormPopup(true);
        setFormSubmitted(false); // Reset form submission when opening popup
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // You can add form validation or API call here
        setFormSubmitted(true);
    };


    // 

    // Form PHP
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // Optional: basic validation
        if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
            setResponseMessage("Please fill in all fields.");
            setLoading(false);
            return;
        }

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/contact-form-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
                setShowFormPopup(false); // close form
                setShowThankYouPopup(true); // open thank-you popup
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    // Form PHP


    // Function to attach hover events
    const attachHoverEvents = (swiperRef) => {
        if (swiperRef.current && swiperRef.current.el) {
            swiperRef.current.el.addEventListener("mouseenter", () => {
                if (swiperRef.current.autoplay && swiperRef.current.autoplay.running) {
                    swiperRef.current.autoplay.stop();
                    console.log("Autoplay stopped"); // Debug log
                }
            });
            swiperRef.current.el.addEventListener("mouseleave", () => {
                if (swiperRef.current.autoplay && !swiperRef.current.autoplay.running) {
                    swiperRef.current.autoplay.start();
                    console.log("Autoplay started"); // Debug log
                }
            });
        }
    }

    // Attach hover events after Swiper initializes
    useEffect(() => {
        if (swiperRef.current) {
            attachHoverEvents(swiperRef);
            console.log("Swiper initialized:", swiperRef.current); // Debug log
        }
        // Cleanup event listeners on unmount
        return () => {
            if (swiperRef.current && swiperRef.current.el) {
                swiperRef.current.el.removeEventListener("mouseenter", () => { });
                swiperRef.current.el.removeEventListener("mouseleave", () => { });
            }
        };
    }, []);

    // Ensure swiper instance is correctly assigned after initialization
    useEffect(() => {
        if (swiperRef.current) {
            console.log("Swiper initialized:", swiperRef.current); // Debug log
        }
    }, []);

    const handleMouseEnter = () => {
        const swiper = swiperRef.current;
        if (swiper && swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
            console.log("Autoplay stopped"); // Debug log
        }
    };

    const handleMouseLeave = () => {
        const swiper = swiperRef.current;
        if (swiper && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
            console.log("Autoplay started"); // Debug log
        }
    };



    const { category } = useParams();
    const navigate = useNavigate();

    // All useState hooks at the top
    const [activeTab, setActiveTab] = useState("description");
    const [showSidebar, setShowSidebar] = useState(false);
    const [filteredProducts, setFilteredProducts] = useState(productData);
    const [activeCategory, setActiveCategory] = useState(category || "all");
    const [activeThumb, setActiveThumb] = useState(0);

    const product = productData.find((p) => p.category === category);

    // Sync activeCategory with URL param
    useEffect(() => {
        setActiveCategory(category || "all");
        if (category) {
            setFilteredProducts(productData.filter((p) => p.category === category));
        } else {
            setFilteredProducts(productData);
        }
    }, [category]);

    // Early return after hooks
    if (!product && category) return <div className="text-center mt-5">Product not found</div>;

    const toggleSidebar = () => setShowSidebar(!showSidebar);

    const handleFilter = (selectedCategory) => {
        setActiveCategory(selectedCategory);
        setShowSidebar(false);

        if (selectedCategory === "all") {
            setFilteredProducts(productData);
            navigate('/products');
        } else {
            setFilteredProducts(productData.filter((product) => product.category === selectedCategory));
            navigate(`/product-details/${selectedCategory}`);
        }
    };




    return (
        <div className="container p-0">
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
                <div className="d-flex justify-content-between container">
                    <h5 className="fw-bold">Products</h5>
                    <ol className="breadcrumb fs-sm-14">
                        <li className="breadcrumb-item">
                            <NavLink to="/" className="text-dark">Home</NavLink>
                        </li>
                        <li className="breadcrumb-item">
                            <NavLink to="/products" className="text-dark">Products</NavLink>
                        </li>
                        <li className="breadcrumb-item active text-primary fw-bold" aria-current="page">
                            {product.name}
                        </li>
                    </ol>
                </div>
            </nav>

            <div className="container-fluid">
                <div className="container p-0">
                    <div className="row">
                        {/* Left Sidebar */}
                        <div className={`col-lg-3 col-md-3 sidebar  ${showSidebar ? "show" : ""}`}>
                            <div className="py-lg-0 py-4">
                                {/* Close Icon */}
                                <div className="close-icon d-lg-none" onClick={toggleSidebar}>
                                    <FaTimes size={24} />
                                </div>

                                <ul className="list-group product-filter">
                                    <li
                                        className={`list-item ${activeCategory === "all" ? "active" : ""}`}
                                        onClick={() => handleFilter("all")}
                                    >
                                        All Products
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pv" ? "active" : ""}`}
                                        onClick={() => handleFilter("pv")}
                                    >
                                        PV Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "premier" ? "active" : ""}`}
                                        onClick={() => handleFilter("premier")}
                                    >
                                        PREMIER Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "ps" ? "active" : ""}`}
                                        onClick={() => handleFilter("ps")}
                                    >
                                        PS Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pxl" ? "active" : ""}`}
                                        onClick={() => handleFilter("pxl")}
                                    >
                                        PXL Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p2be" ? "active" : ""}`}
                                        onClick={() => handleFilter("p2be")}
                                    >
                                        P2BE Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p501" ? "active" : ""}`}
                                        onClick={() => handleFilter("p501")}
                                    >
                                        P501 Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pws" ? "active" : ""}`}
                                        onClick={() => handleFilter("pws")}
                                    >
                                        PWS Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pa" ? "active" : ""}`}
                                        onClick={() => handleFilter("pa")}
                                    >
                                        PA Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pat" ? "active" : ""}`}
                                        onClick={() => handleFilter("pat")}
                                    >
                                        PAT Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pshr" ? "active" : ""}`}
                                        onClick={() => handleFilter("pshr")}
                                    >
                                        PSHR Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "ptc" ? "active" : ""}`}
                                        onClick={() => handleFilter("ptc")}
                                    >
                                        PTC Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "plh" ? "active" : ""}`}
                                        onClick={() => handleFilter("plh")}
                                    >
                                        PLH Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "wxp" ? "active" : ""}`}
                                        onClick={() => handleFilter("wxp")}
                                    >
                                        WXP Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p9000" ? "active" : ""}`}
                                        onClick={() => handleFilter("p9000")}
                                    >
                                        P9000
                                    </li>
                                </ul>

                                <div className="subscribe-box mt-4">
                                    <h5 className="fw-bold text-blue mb-4 text-center">Reach out to us !</h5>
                                    <div className="form-container">
                                        {!formSubmitted ? (
                                            <form onSubmit={handleSubmit}>
                                                <div className="input-group flex-column">

                                                    {/* Full Name */}
                                                    <label className="fw-medium">
                                                        Name <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <User size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="fullName"
                                                                type="text"
                                                                placeholder="Enter your name"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                required
                                                                value={formData.fullName}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <label className="fw-medium">
                                                        Email <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <Mail size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="email"
                                                                type="email"
                                                                placeholder="Enter your email"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                required
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Phone */}
                                                    <label className="fw-medium">Phone</label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <Phone size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="phone"
                                                                type="tel"
                                                                placeholder="Enter your phone number"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                value={formData.phone}
                                                                onChange={handleChange}
                                                                onKeyDown={(e) => {
                                                                    const allowedKeys = [
                                                                        "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                                                        "Tab", "Home", "End", "+", "-", "(", ")", " "
                                                                    ];
                                                                    const isNumber = /^[0-9]$/.test(e.key);
                                                                    const isAllowed = allowedKeys.includes(e.key);
                                                                    if (!isNumber && !isAllowed) e.preventDefault();
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Message */}
                                                    <label className="fw-medium mt-3">Message</label>
                                                    <div className="input-wrapper rounded-20">
                                                        <textarea
                                                            name="message"
                                                            placeholder="Your Message"
                                                            rows="4"
                                                            className="form-control rounded-0 ps-2"
                                                            required
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Submit Button */}
                                                    <div className="d-flex justify-content-center">
                                                        <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                                            {loading ? "Sending..." : "Submit"}
                                                        </button>
                                                    </div>
                                                </div>

                                                {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                                            </form>
                                        ) : (
                                            <div className="text-center p-4">
                                                <p>Thank you for reaching out! We'll get back to you soon.</p>
                                                <button
                                                    className="btn btn-primary mt-3 px-4"
                                                    onClick={() => {
                                                        setFormSubmitted(false);
                                                        setShowThankYouPopup(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Content Section */}
                        <div className="col-lg-9 product-content">

                            <div className="row p-lg-5 p-2">
                                <div className="product-detail-img p-md-5 p-3 position-relative">
                                    <div className="row justify-content-between flex-wrap-reverse">
                                        <div className="col-md-4 text-center">
                                            <h2 className="mb-4 text-blue">{product.name}</h2>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="product-detail-img-right text-start">
                                                <img src={product.image} alt={product.name} className="img-fluid w-75 p-3 mt-md-0 mt-4" />
                                                <div className="product-detail-img-right-btn position-absolute">
                                                    <a href={product.brochure} className="btn btn-outline-primary mt-3 fs-7 fs-sm-10" download>
                                                        Download Brochure <FaChevronDown className="ms-2" size={14} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3 d-flex justify-content-start gap-2">
                                    {[0].map((index) => (
                                        <img
                                            key={index}
                                            src={product.image}
                                            alt={`thumb-${index}`}
                                            width="100"
                                            className={`img-thumbnail rounded-0 p-2 ${activeThumb === index ? "border-primary border" : ""
                                                }`}
                                            onClick={() => setActiveThumb(index)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    ))}
                                </div>
                                {/* Filter Icon - Toggles Sidebar */}
                                <div className="d-lg-none filter-icon mt-3 position-fixed" onClick={toggleSidebar}>
                                    <FaFilter size={24} />
                                </div>
                                {/* Tabs */}
                                <div className="mt-md-5 mt-3">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === "description" ? "active" : ""}`}
                                                onClick={() => setActiveTab("description")}
                                            >
                                                Description
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === "features" ? "active" : ""}`}
                                                onClick={() => setActiveTab("features")}
                                            >
                                                Constructional Features
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content py-4">
                                        {activeTab === "description" ? (
                                            <div>
                                                {/* <p className="mb-4">{product.description.intro}</p> */}
                                                <p className="mb-4" dangerouslySetInnerHTML={{ __html: product.description.intro }} />
                                                <p className="mb-2 fw-bold">{product.description.capacity} </p>
                                                <p className="mb-2 text-blue fw-bold"> {product.description.maxVacuum}</p>
                                                <ul>
                                                    {product.description.features.map((feature, index) => (
                                                        <li key={index} className="mb-1">{feature}</li>
                                                    ))}
                                                </ul>
                                                {/* <div dangerouslySetInnerHTML={{ __html: product.description.features }} /> */}

                                            </div>
                                        ) : (
                                            <div>
                                                {/* Render intro with <br /> formatting */}
                                                <div dangerouslySetInnerHTML={{ __html: product.constructionalFeatures.intro }} className="cons-features" />

                                                {/* Render each feature (as plain text or HTML if needed) */}
                                                {product.constructionalFeatures.features.map((feature, index) => (
                                                    <p key={index}>{feature}</p>
                                                ))}
                                            </div>

                                        )}
                                    </div>
                                    {/* <div className="tab-content  py-4">
                                        {activeTab === "description" ? (
                                            <div>
                                                <p className="mb-4">
                                                    Classic single stage Liquid Ring Vacuum Pumps with a large presence in the Pulp,
                                                    Paper and Thermal power industry.
                                                </p>

                                                <p className="mb-1">
                                                    CAPACITY : 150 to 25500 m³/h (88 CFM TO 15000 CFM)
                                                </p>

                                                <p className="mb-1">
                                                    MAX. VACUUM : 700 mm Hg (27.5" Hg) at Mean Sea Level
                                                </p>

                                                <ul>
                                                    <li className="mb-1">Wide capacity range</li>
                                                    <li className="mb-1">Variable port design allows efficient power consumption at different vacuum level.</li>
                                                    <li className="mb-1">Due to twin inlets and the inner ring, the pump can be operated as two independent Liquid Ring Vacuum Pumps of half the capacity at different vacuum levels.</li>
                                                    <li className="mb-1">Enhanced capacity can be achieved when handling saturated gas by using inlet spray nozzles provided near the suction flanges of the pump.</li>
                                                    <li className="mb-1">All components are 100% interchangeable with *NASH CL series</li>
                                                    <li className="mb-1">Standard material of construction is Cast Iron, also available in SS 304 and SS 316.</li>
                                                </ul>
                                            </div>
                                        ) : (
                                            <div>
                                                <p>All pumps are built with premium-grade cast iron and designed to operate efficiently in various industrial environments.</p>
                                                <ul>
                                                    <li>Heavy-duty shaft with anti-friction bearings</li>
                                                    <li>High-grade seals for leak-proof performance</li>
                                                    <li>Customizable nozzle sizes available</li>
                                                    <li>Engineered for continuous-duty applications</li>
                                                </ul>
                                            </div>
                                        )}
                                    </div> */}
                                </div>


                            </div>
                            {/* <img src={product.graph} alt={product.name} className="img-fluid p-3 rounded-20" />             */}

                            {/* <CapacityGraph /> */}

                            <div className="product-details-slider px-lg-4">
                                <h3 className="fw-bold my-4">Similar Products</h3>
                                <Swiper
                                    ref={swiperRef}
                                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                                    modules={[Autoplay, Navigation]}
                                    autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false,
                                    }}
                                    speed={1000}
                                    loop={true}
                                    slidesPerView={4}
                                    spaceBetween={20}
                                    navigation={{ nextEl: ".details-next", prevEl: ".details-prev" }}
                                    breakpoints={{
                                        320: { slidesPerView: 2 },
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 2 },
                                        992: { slidesPerView: 3 },
                                    }}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    {productData.map((product, index) => (
                                        <SwiperSlide key={product.category}>
                                            <div
                                                className={`${index % 2 === 0 ? "even-card" : "odd-card"
                                                    } p-md-3 p-1 product-slide-card rounded-15 text-center my-3`}
                                            >
                                                <Link
                                                    to={`/product-details/${product.category}`}
                                                    className="text-decoration-none"
                                                >
                                                    <div className="d-flex flex-column h-100 p-1 p-md-4 justify-content-between">

                                                        <h5 className="fw-bold text-white mb-md-3 mb-0">{product.name}</h5>
                                                        <div className="d-flex justify-content-center">
                                                            <p
                                                                className="product-capacity text-start fs-sm-10 mb-md-2 mb-0"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: product.detail,
                                                                }}
                                                            />
                                                        </div>

                                                        <img
                                                            src={product.image}
                                                            alt={product.name}
                                                            className="card-img-top"
                                                        />

                                                        <a
                                                            href={product.brochure}
                                                            download={`${product.name}-Brochure.pdf`}
                                                            className="btn btn-outline-primary download-brochure mt-2 d-flex align-items-center mx-auto fs-sm-10"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            Download Brochure <FaArrowDown className="ms-2" size={14} />
                                                        </a>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <div className="swiper-navigation mt-3 d-flex justify-content-center gap-3">
                                    <button className="details-prev btn btn-outline-light">Previous</button>
                                    <button className="details-next btn btn-outline-light">Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* thank you popup  */}

            {showThankYouPopup && (
                <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
                    <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
                        <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                            <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
                            <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.net' >support@premierpumps.net</a></p>
                            <button
                                className="btn btn-primary mt-3 px-4"
                                onClick={() => setShowThankYouPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* thank you popup  */}
        </div >
    );
}

export default ProductDetails;